import PurchaseHistoryPageView from 'src/pages/PurchaseHistoryPage/view'
import {
  purchaseCouponListQueryOption,
  useInfiniteScrollQuery,
} from 'src/hooks/react-query/useCustomInfiniteQuery.hook'
import { PurchaseHistoryListSpace, ResponseDataType } from 'src/types/api'
import React, { Dispatch, SetStateAction, useCallback, useEffect } from 'react'
import usePageNav from 'src/hooks/usePageNav.hook'
import { useGlobalStore } from 'src/store/zustand'
import { Loading } from 'src/components/common/Loading'
import RenderIf from 'src/components/common/RenderIf'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import { queryClient } from 'src/router'
import { InfiniteData } from '@tanstack/react-query'
import { useCookies } from 'react-cookie'

export interface PurchaseHistoryPageProps {
  setTarget: Dispatch<SetStateAction<HTMLDivElement | null | undefined>>
  purchaseCouponListData: PurchaseHistoryListSpace.PurchaseListInterface[]
  purchaseCouponNoMore: boolean
  itemsOfStatus: { [key: string]: { text: string; color: string } }
  purchaseHistoryDetailPageNav: (
    Idx: number,
    couponIdx: number,
    couponStatus: string,
    couponType: number,
    couponNumber: string,
  ) => void
  isPurchaseHistorySuccess?: boolean
  isUsablePossessionCouponCnt?: number
}

const itemsOfStatus: { [key: string]: { text: string; color: string } } = {
  '0': { text: '사용 가능', color: 'var(--brand-50)' },
  '1': { text: '사용 완료', color: 'var(--black-50)' },
  '2': { text: '취소 완료', color: 'var(--red-50)' },
  '3': { text: '취소 완료', color: 'var(--red-50)' },
  '4': { text: '기간 만료', color: 'var(--red-50)' },
}

const PurchaseHistoryPage = () => {
  const { purchaseHistoryDetailPageNav } = usePageNav()
  const { purchaseHistoryUnderLineTab } = useGlobalStore()
  const { c_tel } = useCustomCookies()
  const [cookies, , removeCookie] = useCookies(['pg', 'orderId'])

  const {
    data: purchaseHistoryListQueryData,
    isPending: isPurchaseHistoryListPending,
    setTarget,
  } = useInfiniteScrollQuery<PurchaseHistoryListSpace.Request, PurchaseHistoryListSpace.Response>(
    purchaseCouponListQueryOption(purchaseHistoryUnderLineTab, 0, c_tel),
  )

  const isUsablePossessionCouponData = queryClient.getQueryData([
    'purchase_coupon_list',
    '0',
    '0',
    c_tel,
  ]) as InfiniteData<ResponseDataType<PurchaseHistoryListSpace.Response>> | undefined

  const isUsablePossessionCouponCnt = isUsablePossessionCouponData?.pages?.[0]?.Body?.CouponCnt ?? 0

  const purchaseCouponListProcessData = useCallback(() => {
    let result: PurchaseHistoryListSpace.PurchaseListInterface[] | any[] = []

    purchaseHistoryListQueryData?.pages?.map(
      // eslint-disable-next-line array-callback-return
      (element: ResponseDataType<PurchaseHistoryListSpace.Response>) => {
        !!element?.Body?.PurchaseList && result.push(...element?.Body?.PurchaseList)
      },
    )

    return {
      result,
      noMore: !purchaseHistoryListQueryData?.pages?.at(-1)?.Body?.PurchaseList?.length,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseHistoryListQueryData])

  useEffect(() => {
    //결제중 비정상 종료시 남은 데이터 정리
    if (cookies['orderId'] !== undefined) {
      removeCookie('pg', { path: '/' })
      removeCookie('orderId', { path: '/' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const props = {
    setTarget,
    itemsOfStatus,
    purchaseCouponListData: purchaseCouponListProcessData().result,
    purchaseCouponNoMore: purchaseCouponListProcessData().noMore,
    purchaseHistoryDetailPageNav,
    isUsablePossessionCouponCnt,
  }
  return (
    <React.Fragment>
      <RenderIf when={isPurchaseHistoryListPending}>
        <Loading.Default />
      </RenderIf>
      <PurchaseHistoryPageView {...props} />
    </React.Fragment>
  )
}
export default PurchaseHistoryPage
